module.exports = __webpack_public_path__ + "img/circular-dot-dark.a6d3f857.svg";